import React from "react";

const Banner: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center px-4 pt-4 pb-2">
      {/* Red accent line */}
      <div className="w-16 h-1 bg-primary rounded-full mb-4" />

      <h1 className="font-heading text-6xl md:text-8xl font-bold tracking-tighter leading-none mb-3">
        <span className="shimmer-text">
          T1
        </span>
        <span className="text-white glow-text">
          {" "}PRAY
        </span>
      </h1>

      <p className="text-white/50 text-sm md:text-base font-body tracking-widest uppercase">
        Thắp hương cầu nguyện cho T1 chiến thắng
      </p>

      {/* Red accent line */}
      <div className="w-16 h-1 bg-primary rounded-full mt-4" />

      {/* Shrine image hidden - keep for later
      <div className="relative fire-glow">
        <img
          className="w-[16rem] md:w-[22rem] h-auto"
          alt="shrine"
          src="https://i.imgur.com/x5NicDI.png"
        />
        <img
          className="absolute w-[15%] left-[42%] top-[70%]"
          alt="incense"
          src="https://i.imgur.com/RIPG0ym.gif"
          style={{ zIndex: 1 }}
        />
      </div>
      */}
    </div>
  );
};

export default Banner;
